import { render, staticRenderFns } from "./CericManageDashboard.vue?vue&type=template&id=d670bfda&scoped=true&"
import script from "./CericManageDashboard.vue?vue&type=script&lang=js&"
export * from "./CericManageDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CericManageDashboard.vue?vue&type=style&index=0&id=d670bfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670bfda",
  null
  
)

export default component.exports